import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Cookie from "js-cookie";
const userToken = Cookie.get("token");
const baseUrl = process.env.VUE_APP_BASE_API_URL;
Vue.use(VueAxios, axios);

Vue.use(axios);

const getPinjaman = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/loan/loans", {
        params: {
          noa: state.noa,
          paid_off: state.filter
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESPINJAMAN", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getPinjamanMutasi = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/loan/loan-transaction-details", {
        params: {
          nospp: state.nospp
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_REYMUTASIPINJAMAN", res);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  getPinjaman,
  getPinjamanMutasi
};
